import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Typography, Breadcrumbs, Link, Box } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useSnackbar } from '@contexts/SnackbarContext';
import API from '@utils/axios';
import { formError } from '@utils/helpers';
import Layout from '@components/Layout';
import CustomerForm from '@components/customer/CustomerForm';

function CustomerCreatePage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { showMessage } = useSnackbar();
    const form = useRef();

    const [initialData] = useState({
        name: '',
        active: true,
    });

    const handleSubmit = async (data) => {
        try {
            const result = await API.post(`/customers`, data);
            showMessage(t('Customer created successfully'), 'success');
            navigate(`/customers/${result.data.id}`);
        } catch (error) {
            formError(error, t, form.current.setError, showMessage);
        }
    };

    return (
        <Layout>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Breadcrumbs aria-label="breadcrumb">
                    <Link component={RouterLink} to="/customers" underline="hover">{t('Customer management')}</Link>
                    <Typography>{t('Create customer')}</Typography>
                </Breadcrumbs>
                <Link component={RouterLink} to="/customers" underline="hover" sx={{ display: 'flex', alignItems: 'center' }}>
                    <ArrowBackIcon sx={{ mr: 0.5 }} />
                    {t('Back to list')}
                </Link>
            </Box>
            <CustomerForm onSubmit={handleSubmit} ref={form} initialData={initialData} />
        </Layout>
    );
}

export default CustomerCreatePage;
